export const platformTitleMap: any = {
  top_critic_average: 'Top Critic Average',
  critics_recommend: 'Recommend',
  user_score: 'User Score',
  meta_score: 'Metascore',
};
